module.exports = __webpack_public_path__ + "img/pageRight.ee62f52c.svg";